import React from "react";
import { DataEntry, Feature, FeatureForEdit, RuleType } from "@emisgroup/cohort-builder";
import { Environments } from "@emisgroup/cohort-builder-kit";
import {
  Dropdown,
  Input,
  FormElement
} from "../../../../Common/UI/Index";
import { InputType } from "../../../../Common/UI/Types";
import { EntryProps, FeatureProps } from "./Types";
import { EthnicityFilters } from "./Data";
import "./Style.scss";

const noop = (): void => void 0;

interface BandingEthnicityFormViewProps {
  /**
   * Onchange for Band name
   */
  onChange: (e: React.SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  /**
   * Handler to update
   */
  onUpdate: (ruleEntry: EntryProps) => void;
  /**
   * Name of the band
   */
  bandName: string;
  /**
   * Entry data
   */
  entry: EntryProps;
  /**
   * Feature Details
   */
  featureDetails: FeatureProps;
  /**
   * Auth token
   */
  token: string;
  /**
   * Callback function for on change of financial year dropdown
   */
  onFilterChange: (selected: string) => void;
  /**
   * Ethinicity category
   */
  ethnicityCategory: string;
}

/**
 * Responsible for rendering ethnicity banding popup
 * @returns Ethnicity banding popup view
 */
export const BandingEthnicityFormView:
React.FC<BandingEthnicityFormViewProps> = (props: BandingEthnicityFormViewProps) => {
  const {
    onChange,
    onUpdate,
    bandName,
    entry,
    featureDetails,
    token,
    onFilterChange,
    ethnicityCategory
  } = props;

  return (
    <>
      <FormElement
        fieldId="band_name"
        labelText="Name"
        mandatory={true}
        className="ebt-output-config__banding__ethnicity__name"
        id={"ebt-outputConfig-banding-form"}
      >
        <Input
          type={InputType.Text}
          name="band_name"
          onChange={onChange}
          value={bandName}
          id="ebt-outputConfig-banding-ethnicityName"
        />
      </FormElement>
      <FormElement
        fieldId="Ethnicity Filters"
        labelText="Ethnicity category"
        mandatory={true}
        className="ebt-output-config__banding__ethnicity__name"
        id="ebt-outputConfig-banding-ethnicityForm"
      >
        <Dropdown
          name="Ethnicity Filters"
          dataSource={EthnicityFilters}
          value={ethnicityCategory || EthnicityFilters[0].value}
          onChange={onFilterChange}
          id="ebt-outputConfig-banding-ethinicityFilter"
        />
      </FormElement>
      <DataEntry
        ruleType={RuleType.Ethnicity}
        entry={entry}
        feature={featureDetails as Feature}
        features={featureDetails as unknown as FeatureForEdit[]}
        token={token}
        hideHeader={true}
        isConsumedOutsideQB={true}
        onUpdate={onUpdate}
        targetEnv={process.env.APP_TARGET_ENV as Environments}
        onSelectEntryComponent={noop}
        onCloseEntryComponent={noop}
        onDelete={noop}/>
    </>
  );
};
